import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { user } from "redux-store/user/user.selectors";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getLoggedInUser } from "redux-store/user/user.slice";
type PropsType = {
  children?: any;
};

export default function AdminAuth({ children }: PropsType) {
  const [logedIn, setLogedIn] = useState(false);
  const loggedInUser = useSelector(user);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getLoggedInUser())
  }, [])

  useEffect(() => {
    if (loggedInUser?.email !== "" && loggedInUser?.isAdmin) {
      setLogedIn(true);
    } else if (loggedInUser?.email !== "" && !loggedInUser?.isAdmin) {
      navigate("/user/home");
    } else {
      navigate(`/`);
    }
  }, [loggedInUser?.isAdmin]);
  return <>{logedIn && children}</>;
}
